// Campus photo for /colleges/vanderbilt-university: Public domain, by Jbaker08, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AKirklandHallVU.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/vanderbilt-university/; credited under the photo.
const photo = {
    "slug": "vanderbilt-university",
    "alt": "The red brick and stone front of Kirkland Hall, its name carved above the windows, at Vanderbilt University in Nashville, Tennessee",
    "src": "/colleges/vanderbilt-university/campus-1600.webp",
    "srcSmall": "/colleges/vanderbilt-university/campus-800.webp",
    "srcMid": "/colleges/vanderbilt-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/vanderbilt-university/og.jpg",
    "title": "KirklandHallVU",
    "author": "Jbaker08",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AKirklandHallVU.JPG",
    "read": "2026-10-01"
};

export default photo;
